import React, { useRef, useState } from 'react'
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import AddIcon from '@mui/icons-material/Add';
import CustomSearch from '../../../components/CustomSearch';
import { useTranslation } from 'react-i18next';
import {
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    Paper,
    Popper,
    Tooltip,
} from "@mui/material";
import { CustomAdvancedMenuList } from '../../../components/StyledComponents';
import ImportIcon20pxSvg from '../../../assets/images/icons/ImportIcon20pxSvg';
import ExportIcon16pxSvg from '../../../assets/images/icons/ExportIcon16pxSvg';
import AddRegistrationsDialog from './AddRegistrationsDialog';
import VisitorTabGridInfoRegistraionsTable from './VisitorTabGridInfoRegistraionsTable';
import { ControlpanelSuccess3thButton } from '../../../components/StyledButton';
import { addDays, startOfDay } from "date-fns";
import CalendarToday from "../../../assets/images/icons/CalendarToday";
import CustomDateRangePicker from "../../../components/CustomDateRangePicker";
import { useAuth } from "../../../context/AuthContext";
import { LoadingProvider } from '../../../context/LoadingContext';
import CustomDateTimePicker from '../../../components/CustomDateTimeRangePicker';
import dayjs from "dayjs";
import ImportIcon16pxSvg from '../../../assets/images/icons/ImportIcon16pxSvg';

const RequestsTab = ({ eventVisitorId, refreshData, onRefresh, refresh, dataInfo }) => {
    const [openAdvanced, setOpenAdvanced] = useState(false);
    const { t } = useTranslation();
    const [selectedRow, setSelectedRow] = useState({});
    const [addRegistrationsOpen, setAddRegistrationsOpen] = useState(false);
    const { genaralSettingDateFormat } = useAuth();

    const [selectedDate, setSelectedDate] = useState(
        startOfDay(new Date())
    );

    const [isDateFiltered, setIsDateFiltered] = useState(false);

    const handleGoToToday = () => {
        setSelectedDate(startOfDay(new Date()));
        setIsDateFiltered(true);
    };

    const anchorRefAdvanced = useRef(null);
    const [searchText, setSearchText] = useState("");

    const handleQuickFilterChange = (value) => {
        setSearchText(value);
    };
    const handleToggleAdvanced = () => {
        setOpenAdvanced((prev) => !prev);
    };
    const handleCloseAdvanced = (event) => {
        if (
            anchorRefAdvanced.current &&
            anchorRefAdvanced.current.contains(event.target)
        ) {
            return; // click vào button thì không close
        }
        setOpenAdvanced(false);
    };

    return (
        <>
            <div>
                <div className="flex items-center gap-3">
                    {/* TODAY */}
                    <Tooltip title={t("button.select-today")} arrow>
                        <div
                            className="flex items-center justify-center w-10 h-10 cursor-pointer select-none border border-[#E5E7EB] rounded-[6px]"
                            onClick={handleGoToToday}
                        >
                            <CalendarToday
                                fontSize="small"
                                className="text-[#1F2937]"
                            />
                        </div>

                    </Tooltip>

                    {/* RANGE PICKER */}
                    <div className="min-w-[280px]">
                        <CustomDateTimePicker
                            mode="single"
                            disableTime
                            showOnlyDate
                            value={selectedDate}
                            onChange={(date) => {
                                setSelectedDate(date);
                                setIsDateFiltered(true);
                            }}
                        />
                    </div>
                    {/* SEARCH */}
                    <div className="flex-1">
                        <CustomSearch
                            onSearchChange={handleQuickFilterChange}
                        />
                    </div>

                    {/* BUTTON GROUP */}
                    {/* ADD */}
                    <ControlpanelSuccess3thButton
                        onClick={() => setAddRegistrationsOpen(false)}
                        className='pointer-events-none opacity-50'
                    >
                        <ExportIcon16pxSvg color='#0057FF' />
                        {t("button.import-data")}
                    </ControlpanelSuccess3thButton>
                </div>

                <div className='mt-4'>
                    <LoadingProvider>
                        <VisitorTabGridInfoRegistraionsTable isDateFiltered={isDateFiltered} eventVisitorId={eventVisitorId} selectedDate={dayjs(selectedDate).format("YYYY-MM-DD")} searchText={searchText} onRowClick={setSelectedRow} refreshData={refreshData} onRefresh={onRefresh} refresh={refresh} dataInfo={dataInfo} />
                    </LoadingProvider>
                </div>
            </div >

            {addRegistrationsOpen && <AddRegistrationsDialog dataInfo={dataInfo} onClose={() => setAddRegistrationsOpen(false)} refreshData={refreshData} onRefresh={onRefresh} refresh={refresh} />}

            <Popper
                open={openAdvanced}
                anchorEl={anchorRefAdvanced.current}
                placement="bottom-start"
                transition
                disablePortal
                className="z-10"
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === "bottom" ? "left top" : "left bottom",
                        }}
                    >
                        <Paper style={{ borderRadius: "8px", }}>
                            <ClickAwayListener onClickAway={handleCloseAdvanced}>
                                <CustomAdvancedMenuList
                                    id="advanced-menu"
                                    aria-labelledby="advanced-button"
                                >
                                    <MenuItem
                                        style={{
                                            borderBottom: "1px solid #E5E7EB",
                                            opacity: "0.5",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <Link>
                                            <ImportIcon16pxSvg />
                                            <p>{t("button.import-data")}</p>
                                        </Link>
                                    </MenuItem>

                                    <MenuItem
                                        style={{
                                            borderBottom: "1px solid #E5E7EB",
                                            opacity: "0.5",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <Link>
                                            <ExportIcon16pxSvg />
                                            <p>{t("button.export-data")}</p>
                                        </Link>
                                    </MenuItem>
                                </CustomAdvancedMenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}

export default RequestsTab